import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-053ada1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "role-list-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "用户类型：", -1));
const _hoisted_6 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_7 = {
  class: "pagination-box"
};
import { ref, onMounted } from 'vue';
import { rolePage, delRole } from '@/api/role';
import { ElMessageBox, ElMessage } from 'element-plus';
import DistributePermission from './components/Permission';
import Role from './components/Role';
import SelectSearch from '@/components/SelectSearch';
import usePagination from '@/hooks/usePagination';
import { Search, Refresh } from '@element-plus/icons-vue';
// import BatchRole from './components/BatchRole'

export default {
  __name: 'index',
  setup(__props) {
    const allRole = ref([]);
    const loading = ref(false);
    const searchValue = ref('');

    // const handleSelectChange = () => {
    //   getRoleList()
    // }

    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const name = ref('');
    const getRoleList = async () => {
      loading.value = true;
      const res = await rolePage({
        tenantId: searchValue.value,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        name: name.value
      });
      allRole.value = res.records;
      setTotal(res.total);
      loading.value = false;
    };
    onMounted(() => {
      getRoleList();
    });
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getRoleList();
    };
    const handleRefresh = () => {
      name.value = '';
      searchValue.value = '';
      getRoleList();
    };

    /**
     * 分配权限
     */
    const selectRoleId = ref('');
    const distributePermissionVisible = ref(false);
    const onDistributePermissionClick = row => {
      distributePermissionVisible.value = true;
      selectRoleId.value = row.id;
    };
    const onDeleteRoleHandler = row => {
      ElMessageBox.confirm('您确定要删除该条角色', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        await delRole(row.id);
        ElMessage({
          type: 'success',
          message: '退出成功'
        });
        getRoleList();
      });
    };
    const addRoleVisible = ref(false);
    const handleAddRole = () => {
      currentRole.value = null;
      addRoleVisible.value = true;
    };
    const currentRole = ref(null);
    const handleUpdateRole = row => {
      currentRole.value = row;
      addRoleVisible.value = true;
    };

    // const batchRoleVisible = ref(false)
    // const handleBatchAddRole = () => {
    //   currentRole.value = null
    //   batchRoleVisible.value = true
    // }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
          placeholder: "请输入关键字",
          style: {
            "width": "250px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_unref(SelectSearch), {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchValue.value = $event)
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getRoleList
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddRole
        }, {
          default: _withCtx(() => [_createTextVNode(" 添加角色 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: allRole.value,
          border: "",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "#",
            type: "index"
          }), _createVNode(_component_el_table_column, {
            prop: "tenantName",
            label: "所属租户"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名字"
          }), _createVNode(_component_el_table_column, {
            prop: "clientId",
            label: "归属客户端id"
          }), _createVNode(_component_el_table_column, {
            prop: "code",
            label: "角色编码"
          }), _createVNode(_component_el_table_column, {
            prop: "description",
            label: "角色描述"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            prop: "action",
            width: "350"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => onDistributePermissionClick(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 分配接口权限 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "info",
              size: "small",
              onClick: $event => handleUpdateRole(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => onDeleteRoleHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['roleDelete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(DistributePermission), {
        modelValue: distributePermissionVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => distributePermissionVisible.value = $event),
        roleId: selectRoleId.value,
        onUpdateRole: getRoleList
      }, null, 8, ["modelValue", "roleId"]), addRoleVisible.value ? (_openBlock(), _createBlock(_unref(Role), {
        key: 0,
        modelValue: addRoleVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => addRoleVisible.value = $event),
        model: currentRole.value,
        onRefreshData: getRoleList,
        onClearModel: _cache[4] || (_cache[4] = $event => currentRole.value.value = null),
        title: "新增"
      }, null, 8, ["modelValue", "model"])) : _createCommentVNode("", true)]);
    };
  }
};